import script from "./CalcInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CalcInput.vue?vue&type=script&setup=true&lang=js"

import "./CalcInput.vue?vue&type=style&index=0&id=5ecabd54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecabd54"]])

export default __exports__